var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2995_26042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50413 1.31228C7.26151 0.704627 9.2331 0.717742 10.9817 1.36036C11.9522 1.71883 12.8397 2.2784 13.6003 2.98222C13.3468 3.25763 13.0713 3.51556 12.8091 3.78222L11.314 5.2773C10.82 4.80517 10.2167 4.4467 9.56096 4.24561C8.79157 4.01392 7.96097 3.97894 7.17408 4.14944C6.25605 4.34616 5.40359 4.82703 4.74348 5.50026C4.21015 6.03796 3.80796 6.70244 3.56315 7.41938C2.67572 6.72867 1.78829 6.04233 0.896484 5.35162C1.83638 3.47184 3.52381 1.98987 5.50413 1.31228Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.900913 5.34375C1.78834 6.03446 2.67578 6.7208 3.56758 7.41151C3.21785 8.43009 3.21785 9.56233 3.56758 10.5765C2.68015 11.2672 1.79272 11.958 0.905284 12.6443C0.0834263 11.0399 -0.165754 9.15577 0.192716 7.38965C0.336978 6.68145 0.573044 5.99074 0.900913 5.34375Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8119 7.47266C16.0654 8.90216 16.0086 10.3929 15.6064 11.7918C15.2348 13.0727 14.531 14.2617 13.5474 15.1666L10.9638 13.1601C11.8162 12.5874 12.4195 11.6606 12.59 10.6464H8.15723C8.1616 9.5885 8.1616 8.53058 8.1616 7.47266H15.8119Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55878 10.582C3.89976 11.5831 4.5555 12.4706 5.42107 13.0782C5.96315 13.4585 6.58392 13.7296 7.23091 13.8607C7.86916 13.9919 8.52927 13.9744 9.1719 13.8651C9.81015 13.7514 10.4265 13.5197 10.9642 13.1569L13.5479 15.1635C12.6167 16.0247 11.4495 16.6104 10.2167 16.8946C8.85277 17.205 7.41015 17.2137 6.05495 16.8509C4.97954 16.5667 3.96971 16.0553 3.09976 15.3602C2.1861 14.6345 1.42545 13.699 0.896484 12.6498C1.78392 11.9635 2.67135 11.2727 3.55878 10.582Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2995_26042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.2623,
    fill: "white",
    transform: "translate(0 0.867188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google_icon.1ba492ca5fbdd13c013e8aa119362bdf.svg";
export { ForwardRef as ReactComponent };